const menusWrapper = document.querySelector(".menus-wrapper");
const header = document.querySelector(".awesome_index_header");
const menuDrawer = document.querySelector(".menu__drawer");
const menuDrawerBtn = document.querySelector("header-drawer");

// this code handles wrapping element.

function findWrappingElem() {
  const containers = document.querySelectorAll(".flex-container");

  // loop through all
  containers?.forEach((container, index) => {
    const children = container.children;
    // console.log(container, 'container');

    // Get the top position of the first child
    let lastTop = children[0]?.getBoundingClientRect().top;
    let newRow = true;

    // Loop through each child and check if it wraps to a new line
    for (let i = 1; i < children.length; i++) {
      const child = children[i];
      const childTop = child.getBoundingClientRect().top;

      // Check if the child is on a new row
      if (childTop !== lastTop) {
        newRow = true;
        lastTop = childTop;
      }

      // Add class to the first child of each new row
      if (newRow) {
        child.classList.add("wrap-to-new-line");
        newRow = false;
      }

      if (i == 1) {
        // remove uncertaintiy error
        child.classList.remove("wrap-to-new-line");
      }
    }
  });
}

// fucntion to handle menu additional details

function shiftMenuDetail() {}

/**
 * Sets the height and top styles for the menuDrawer based on the header's current height.
 */
function setMenuDrawerStyles() {
  let headerHeight = header.clientHeight;

  let topOffset = headerHeight;

  if (window.matchMedia("(max-width: 575px)").matches) {
    topOffset = headerHeight - 1;
  }

  document.documentElement.style.setProperty(
    "--menu-drawer-height",
    `calc(100% - ${headerHeight}px)`
  );
  document.documentElement.style.setProperty("--menu-drawer-top", `${topOffset}px`);
}

// function to handle menu__drawer toggle
function handleMenuDrawer() {
  menuDrawerBtn?.addEventListener("click", () => {
    menuDrawer.classList.toggle("show-drawer");
  });

  window.addEventListener(
    "resize",
    throttle(() => {
      if (window.matchMedia("(max-width: 990px)").matches) {
        setMenuDrawerStyles();
      }
    }, 300)
  );

  isShifted = false;

  // handle shifting additional details to bottom
  Array.from(menusWrapper.children).forEach((elem, index) => {
    let childElem = elem.querySelector(".navigation-menu.collapsible");

    // add class to parent
    if (childElem?.classList.contains("additional-detail")) {
      if (!isShifted) {
        // add class to first child
        elem.classList.add("shift");
      }
      isShifted = true;
    }
  });
}

/**
 * Sets the `--top-header-height` CSS property to be used by custom--slider Section.
 */
function setHeaderHeightProperty() {
  const header = document.querySelector("[data-site-header]");

  if (header) {
    const headerHeight = `${header.offsetHeight}px`;
    document.documentElement.style.setProperty("--top-header-height", headerHeight);
    document.documentElement.style.setProperty(
      "--body-height",
      parseInt(document.documentElement.clientHeight) - header.offsetHeight + "px"
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // run function
  findWrappingElem();
  // run function
  handleMenuDrawer();

  setMenuDrawerStyles();

  setHeaderHeightProperty();

  // Update height height property value
  window.addEventListener("resize", setHeaderHeightProperty);

  class NavigationMenus extends HTMLElement {
    constructor() {
      super();

      this.menusWrapper = this.querySelector(".menus-wrapper");
      this.navigationMenus = this.querySelectorAll(".navigation-menu.collapsible");

      this.initialPosition = "";
      this.finalPosition = "";
      this.matchedElemId = "";

      // window.innerWidth can be stale at this exact synchronous instant (Chrome
      // DevTools mobile emulation and some real devices haven't always settled
      // their viewport metrics yet here). Re-check right after construction with
      // matchMedia, which reflects live CSS viewport state, and self-correct.
      requestAnimationFrame(() => {
        const matchesDesktop = window.matchMedia("(min-width: 990px)").matches;
        if (matchesDesktop !== this.isDesktop) {
          this.isDesktop = matchesDesktop;
        }
      });

      this.isDesktop = window.innerWidth > 990;

      this.handleResize = () => {
        this.isDesktop = window.innerWidth > 990;

        // optional cleanup when switching modes
        this.navigationMenus.forEach((menu) => {
          if (!this.isDesktop) {
            menu.classList.remove("active");
          }
        });
      };

      this.navigationMenus.forEach((menu) => {
        const menuHeader = menu.querySelector(".menu-tab");
        const menuLink = menu.querySelector(".menu-tab__title");
        const hasDropdown = menu.querySelector(".mega-menu__list-item") !== null;

        if (menuLink) {
          menuLink.setAttribute("aria-haspopup", "true");
          menuLink.setAttribute("aria-expanded", "false");
        }

        menu.addEventListener("mouseenter", () => {
          if (!this.isDesktop) return;
          menu.classList.add("active");
          menuLink?.setAttribute("aria-expanded", "true");
        });

        menu.addEventListener("mouseleave", () => {
          if (!this.isDesktop) return;

          this.initialPosition = "navigation-menu";
          this.navigationMenus.forEach((_menu) => {
            if (_menu.classList.contains("active")) {
              this.matchedElemId = _menu.id;
            }
          });

          menuLink?.setAttribute("aria-expanded", "false");
        });

        menuHeader?.addEventListener("click", (event) => {
          if (this.isDesktop) return;
          if (!hasDropdown) return;

          if (event.target.closest("a.menu-tab__title")) {
            event.preventDefault();
          }

          menu.classList.toggle("show-content");
          menuLink?.setAttribute(
            "aria-expanded",
            menu.classList.contains("show-content").toString()
          );
        });

        menuHeader?.addEventListener("keydown", (event) => {
          if (!hasDropdown) return;
          const toggleKeys = ["Enter", " ", "Spacebar"];
          const isAnchorTarget = event.target.closest("a.menu-tab__title");
          const isOpen = this.isDesktop
            ? menu.classList.contains("active")
            : menu.classList.contains("show-content");

          if (toggleKeys.includes(event.key)) {
            if (isAnchorTarget && isOpen) {
              // allow the second Enter on the anchor to follow the link
              return;
            }

            event.preventDefault();
            if (this.isDesktop) {
              menu.classList.add("active");
            } else {
              menu.classList.toggle("show-content");
            }
            menuLink?.setAttribute(
              "aria-expanded",
              (this.isDesktop
                ? menu.classList.contains("active")
                : menu.classList.contains("show-content")
              ).toString()
            );

            if (this.isDesktop) {
              menu.querySelector(".mega-menu__link")?.focus();
            }
          }

          if (event.key === "Escape") {
            menu.classList.remove("active");
            menu.classList.remove("show-content");
            menuLink?.setAttribute("aria-expanded", "false");
            menuLink?.focus();
          }
        });

        menu?.addEventListener("keydown", (event) => {
          if (event.key !== "Escape") return;
          if (!hasDropdown) return;
          if (!menu.classList.contains("active") && !menu.classList.contains("show-content"))
            return;

          menu.classList.remove("active");
          menu.classList.remove("show-content");
          menuLink?.setAttribute("aria-expanded", "false");
          menuLink?.focus();
        });
      });

      this.menusWrapper?.addEventListener("mousemove", () => {
        if (!this.isDesktop) return;

        if (this.initialPosition === "navigation-menu" && this.matchedElemId) {
          this.menusWrapper.querySelector(`#${this.matchedElemId}`)?.classList.remove("active");

          this.initialPosition = "menus-wrapper";
        }
      });

      this.menusWrapper?.addEventListener("mouseleave", () => {
        if (!this.isDesktop) return;

        if (this.initialPosition === "navigation-menu" && this.matchedElemId) {
          this.initialPosition = "mega-menu";

          this.menusWrapper.querySelector(`#${this.matchedElemId}`)?.classList.remove("active");
        }
      });

      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }

  // register in dom
  customElements.define("navigation-menus", NavigationMenus);
});

// window onload
window.onload = () => {
  if (window.innerWidth < 750) {
    let menuDrawer = document.querySelector(".menu__drawer");
    let header = document.querySelector(".awesome_index_header");
    // initial height for menu drawer;
    let headerHeight = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      "--menu-drawer-height",
      `calc(100% - ${headerHeight}px)`
    );
    document.documentElement.style.setProperty("--menu-drawer-top", `${headerHeight}px`);
  }
};
